// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".date[data-v-4281d53c]{display:flex;flex-direction:column;width:45%}", "",{"version":3,"sources":["webpack://./resources/js/components/common/Period.vue"],"names":[],"mappings":"AACA,uBACI,YAAA,CACA,qBAAA,CACA,SAAA","sourcesContent":["\n.date {\n    display: flex;\n    flex-direction: column;\n    width: 45%;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
